/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React from 'react';
import PropTypes from 'prop-types';
import FilterIcon from '@material-ui/icons/FilterList';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Fade from '@material-ui/core/Fade';
import Button from '@material-ui/core/Button';

const SortBy = (props) => {
    // eslint-disable-next-line object-curly-newline
    const { recipients, anchorEl, selectedIndex, sortByList } = props;
    const { onSortByClicked, onSortByClosed, onSortByMenuItemClick } = props;
    return (
        <div className="split align-center margin-bottom-2x">
            <div className="align-left">
                Total Addresses: {recipients.length}
            </div>
            <div className="align-right">
                <Button
                    variant="outlined"
                    aria-controls="fade-menu"
                    aria-haspopup="true"
                    onClick={(event) => onSortByClicked(event)}
                >
                    <FilterIcon className="margin-right-half" />
                    {sortByList[selectedIndex]}
                </Button>
                <Menu
                    id="fade-menu"
                    anchorEl={anchorEl}
                    keepMounted
                    open={Boolean(anchorEl)}
                    onClose={() => onSortByClosed()}
                    TransitionComponent={Fade}
                >
                    {sortByList.map((option, index) => (
                        <MenuItem
                            key={option}
                            disabled={index === 0}
                            selected={index === selectedIndex}
                            onClick={(event) => onSortByMenuItemClick(event, index)}
                        >
                            {option}
                        </MenuItem>
                    ))}
                </Menu>
            </div>
        </div>
    );
};

SortBy.defaultProps = {
    anchorEl: null,
};

SortBy.propTypes = {
    recipients: PropTypes.array.isRequired,
    anchorEl: PropTypes.object,
    selectedIndex: PropTypes.number.isRequired,
    sortByList: PropTypes.array.isRequired,
    onSortByClicked: PropTypes.func.isRequired,
    onSortByClosed: PropTypes.func.isRequired,
    onSortByMenuItemClick: PropTypes.func.isRequired,
};

export default SortBy;
